﻿window.cObjetDocCptAvoirMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "avoir"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouvel avoir"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined' && objet.data.code != null && objet.data.code.length > 0) { txt = objet.data.code }
        else {
            var txt = "..."
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-sack-xmark' class='avoir'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    //this.mGetBase64Image = function (funcOk, funcKo) {
    //    $.ajax({
    //        type: 'POST',
    //        url: "/handler/handlerImage.ashx" + '?timestamp=' + new Date().getTime(),
    //        async: true,
    //        data: { id_table: objet.mGetTable  ().id_table, id: objet.data.id_article },
    //        success: function (data, status, xhr) {
    //            switch (data.root.resultat) {
    //                case "prise_session": mRedirectOnLogin(true); break;
    //                case "deconnexion": mRedirectOnLogin(false); break;
    //                case "ko": if (funcKo) funcKo(); break;
    //                case "ok":
    //                    funcOk(data.root.base64)
    //                    break;
    //            }
    //        },
    //        complete: function (xhr, status) { },
    //        error: function (xhr, status, error) { if (funcKo) funcKo(); }
    //    })
    //}

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        if (type == "Détails") {
            $("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;' colspan='5'>" + dataTemplate.code + "</div>").appendTo(contentElement)
        }
        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdUti = $("<td style='width:30px;padding:0 3px;height:1px;'/>")
        $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: ((dataTemplate.id_utilisateur == null) ? "" : objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1())
        })

        var $TdDest = $("<td style='width:30px;padding:0 3px;height:1px;'/>")
        var $TdNomclient = null
        if (dataTemplate.id_table_client == null) {
            $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                icon1: "fas fa-portrait",
                icon2: "fas fa-question",
                text: ""
            })
            $TdNomclient = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:50%;'>" + ((dataTemplate.nom_client == null) ? "(Aucun client)" : dataTemplate.nom_client) + "</td>")
        } else {
            $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                icon1: "fas fa-portrait",
                icon2: "",
                idTable: dataTemplate.id_table_client,
                id: dataTemplate.id_client,
                text: dataTemplate.nom_client
            })
            $TdNomclient = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:50%;'>" + ((dataTemplate.nom_client == null) ? "(Aucun client)" : dataTemplate.nom_client) + "</td>")
        }

        if (type == "Lignes") {
            var $TdCode = $("<td style='overflow:hidden;text-overflow:ellipsis;width:50%;padding:0 3px;'>" + dataTemplate.code + "</td>").appendTo($Tr)
        }

        var $TdExpire = $("<td style='width:130px;padding:0 3px;'></td>").appendTo($Tr)
        if (dataTemplate.used == "1") {
            $Table.css("text-decoration", "line-through")
            $TdExpire.css("color", "red")
            $TdExpire.text("Utilisé le " + dataTemplate.date_utilisation.toDDMMAA())
        } else if (dataTemplate.date_fin < parametre.dateNow) {
            $Table.css("text-decoration", "line-through")
            $TdExpire.css("color", "red")
            $TdExpire.text("Expiré le " + dataTemplate.date_fin.toDDMMAA())
        } else {
            $TdExpire.css("color", "green")
            $TdExpire.text("Expire le " + dataTemplate.date_fin.toDDMMAA())
        }

        var $TdMt = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:90px;text-align:right;'><span class='dx-field-item-label-text' style='font-size:70%'></span>" + parseFloat(dataTemplate.mt).formatDisplay() + "€</td>").appendTo($Tr)

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    //this.itemTemplateGrille = function (contentElement, type) {


    //    if (type == "Détails") {
    //        $("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;' colspan='5'>" + objet.data.code + "</div>").appendTo(contentElement)
    //    }
    //    var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
    //    var $Tr = $("<tr/>").appendTo($Table)

    //    var $TdUti = $("<td style='width:30px;padding:0 3px;'/>").appendTo($Tr)
    //    objet.bddRef.mAjaxCall({ command: "getidutilisateurcreateur", id_table: Me.objet.mGetTable().id_table, id: Me.objet.cle() }, function (data) {
    //        var opt = {
    //            bddCtrl: objet.bddRef,
    //            data: objet.bddRef.getObjet("utilisateur", data.id_utilisateur).data,
    //            size: 22,
    //            allowClick: false,
    //            onClick: null
    //        }
    //        $("<div style=''/>").appendTo($TdUti).dxCtrlImageData(opt).dxCtrlImageData("instance")
    //    })

    //    if (type == "Lignes") {
    //        var $TdCode = $("<td style='overflow:hidden;text-overflow:ellipsis;width:50%;padding:0 3px;'>" + objet.data.code + "</td>").appendTo($Tr)
    //    }
    //    var $TdDest = $("<td style='overflow:hidden;text-overflow:ellipsis;width:30px;padding:0 3px;'/>").appendTo($Tr)
    //    var $TdLibDest = $("<td style='width:" + ((type == "Lignes") ? "50%" : "100%") + ";padding:0 3px;'></td>").appendTo($Tr)
    //    var req = "select top 1 doc_cpt_client.* from doc_cpt_avoir " +
    //        "inner join doc_cpt_mode_reglement " +
    //        "ON doc_cpt_avoir.id_doc_cpt_mode_reglement_source=doc_cpt_mode_reglement.id_doc_cpt_mode_reglement " +
    //        "inner join doc_cpt_client " +
    //        "ON doc_cpt_mode_reglement.id_doc_cpt=doc_cpt_client.id_doc_cpt where doc_cpt_avoir.id_doc_cpt_avoir=" + objet.data.id_doc_cpt_avoir
    //    objet.bddRef.mAjaxCall({
    //        command: "getdatas",
    //        nomtable: "doc_cpt_avoir",
    //        sql: req
    //    }, function (data) {
    //        if (typeof data.doc_cpt_avoir == 'undefined') data.doc_cpt_avoir = []
    //        if (data.doc_cpt_avoir.length > 0 && data.doc_cpt_avoir[0].id_table != null) {
    //            $TdLibDest.text(data.doc_cpt_avoir[0].nom)
    //            var optImagDest = {
    //                bddCtrl: Me.objet.bddRef,
    //                size: 22,
    //                onClick: null,
    //                allowClick: false,
    //                icone: "fas fa-user",
    //                txtooltip: "inconnu",
    //                id_table: data.doc_cpt_avoir[0].id_table,
    //                id: data.doc_cpt_avoir[0].id
    //            }
    //            $("<div class='state-hover2'/>").appendTo($TdDest).dxCtrlImageData(optImagDest).dxCtrlImageData("instance")
    //            $TdLibDest.text(data.doc_cpt_client[0].nom)
    //            $TdDest.on("click", function (e) {
    //                e.stopPropagation()
    //                objet.bddRef.getObjet(objet.bddRef.table.mGetItem(optImagDest.id_table).nom, optImagDest.id).mShowPopup()
    //            })
    //        }
    //    }, function () { })

    //    var $TdExpire = $("<td style='width:130px;padding:0 3px;'></td>").appendTo($Tr)
    //    if (objet.data.used == "1") {
    //        $Table.css("text-decoration", "line-through")
    //        $TdExpire.css("color", "red")
    //        $TdExpire.text("Utilisé le " + objet.data.date_utilisation.toDDMMAA())
    //    } else if (objet.data.date_fin < parametre.dateNow) {
    //        $Table.css("text-decoration", "line-through")
    //        $TdExpire.css("color", "red")
    //        $TdExpire.text("Expiré le " + objet.data.date_fin.toDDMMAA())
    //    } else {
    //        $TdExpire.css("color", "green")
    //        $TdExpire.text("Expire le " + objet.data.date_fin.toDDMMAA())
    //    }

    //    var $TdMt = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:90px;text-align:right;'><span class='dx-field-item-label-text' style='font-size:70%'></span>" + parseFloat(objet.data.mt).formatDisplay() + "€</td>").appendTo($Tr)

    //}
    //this.itemTemplateGrillePlus = function (contentElement, type) {
    //    $("<span style='font-family:barlow condensed;'>" + objet.data.dcr.toFrenchDateTime() + " &bull; Créé " + objet.data.dcr.toDateIlya(false) + "</span>").appendTo(contentElement)
    //}

    this.mShowDocCpt = function () {
        //var req = "select top 1 doc_cpt_mode_reglement.id_doc_cpt from doc_cpt_avoir " +
        //    "inner join doc_cpt_mode_reglement " +
        //    "ON doc_cpt_avoir.id_doc_cpt_mode_reglement_source=doc_cpt_mode_reglement.id_doc_cpt_mode_reglement " +
        //    "where doc_cpt_avoir.id_doc_cpt_avoir=" + objet.data.id_doc_cpt_avoir
        //objet.bddRef.mAjaxCall({
        //    command: "getdatas",
        //    nomtable: "doc_cpt_avoir",
        //    sql: req
        //}, function (data) {
        objet.bddRef.mAjaxCall({
            command: "getdatasdoccptavoir",
            id_doc_cpt_avoir: objet.data.id_doc_cpt_avoir
        }, function (data) {
            data.doc_cpt_avoir = JSON.parse(data.doc_cpt_avoir)
            //if (typeof data.doc_cpt_avoir == 'undefined') data.doc_cpt_avoir = []
            objet.bddRef.getObjet("doc_cpt", data.doc_cpt_avoir[0].id_doc_cpt).mShowPopup()
        }, function () { })
    }

}